import React from 'react';

import sAction from 'sAction';
import Select from 'ROOT/src/components/formElements/Select';
import LoginFormDefault from 'ROOT/src/components/login/LoginForm';

export default class LoginForm extends LoginFormDefault {
    render() {
        return (
            <>
                <div className="loginBoxContainer" onKeyDown={(e) => this.onKeyDown(e)}>
                    <div className='languageSelectWrapper'>
                        <Select
                            value={this.state.language}
                            onChange={(e) => this.setlanguage(e.target.value)}
                            options={[
                                {value: 'en_us', label: 'English'},
                                {value: 'es_ES', label: 'Español'},
                            ]}
                            className="languageSelect"
                        />
                    </div>
                    <h1 className="loginHeadline">
                        ERN {sAction.translate('LBL_SUPPORT_SITE')}
                    </h1>

                    <div className="loginInputWrapper">
                        <label>{sAction.translate('LBL_LOGIN_NAME')}</label>
                        <input type="text" className="loginInput" placeholder="" ref={this.name} />
                    </div>

                    <div className="loginInputWrapper">
                        <label>{sAction.translate('LBL_LOGIN_PASSWORD')}</label>
                        <input type="password" className="loginInput" placeholder="" ref={this.pass} />
                    </div>

                    <div className="signInBtnWrapper">
                        <a className="button full signInBtn" onClick={() => this.submit()}>
                            {sAction.translate('LBL_LOGIN', 'default')}
                        </a>
                    </div>

                    <a className="resetPasswdLink" onClick={() => this.props.goToResetPassword()}>
                        {sAction.translate('LBL_FORGOTTEN_PASSWORD')}
                    </a>

                    <div className="signInBtnWrapper">
                        <a className="button outlined reqestAccesBtn"
                            onClick={() => this.props.goToRequestAccess()}>
                            {sAction.translate('LBL_REQUEST_ACCESS')}
                        </a>
                    </div>
                </div>
            </>
        );
    }
}
